var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"top":"","timeout":_vm.snacktimeout,"color":_vm.snackcolor},model:{value:(_vm.warningZone),callback:function ($$v) {_vm.warningZone=$$v},expression:"warningZone"}},[_vm._v("\n            "+_vm._s(_vm.snacktext)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }